(() => {
  const labels = document.currentScript?.dataset || {};
  let active;
  let lastScroll = 0;
  window.addEventListener('scroll', () => { lastScroll = performance.now(); }, {passive:true});
  const waitForScroll = async state => {
    while (performance.now() - lastScroll < 220) {
      if (state !== active || state.url !== location.href || state.controller.signal.aborted) return false;
      await new Promise(resolve => setTimeout(resolve, 100));
    }
    return state === active && state.url === location.href && !state.controller.signal.aborted;
  };
  const nextURL = scope => scope.querySelector('.pagination__item--prev[href]')?.href || '';
  function init() {
    const grid = document.querySelector('#product-grid');
    if (!grid || !grid.matches('ul') || grid === active?.grid) return;
    active?.controller?.abort(); active?.observer?.disconnect(); active?.button?.remove(); active?.status?.remove();
    const container = document.querySelector('#ProductGridContainer');
    const snapshot = window.NJTListReturn?.snapshot('#product-grid');
    const state = {grid, container, url:location.href, next:nextURL(container), pages:1, busy:false};
    active = state;
    if (snapshot) {
      grid.innerHTML = snapshot.html; state.next = snapshot.next; state.pages = snapshot.pages || 1;
      grid.dataset.listReady = 'true';
    }
    const pagination = container.querySelector('.pagination-wrapper');
    if (pagination) pagination.hidden = true;
    const button = document.createElement('button');
    button.type = 'button'; button.className = 'njt-infinite-more'; button.textContent = labels.more || 'Show more options';
    const status = document.createElement('p');
    status.className = 'njt-infinite-status'; status.setAttribute('role','status'); status.setAttribute('aria-live','polite');
    grid.insertAdjacentElement('afterend',status); status.after(button);
    state.button = button; state.status = status;
    const sync = () => { button.hidden = !state.next; grid.dataset.nextPage = state.next; grid.dataset.loadedPages = state.pages; };
    const load = async () => {
      if (state.busy || !state.next || state !== active || state.url !== location.href) return;
      state.busy = true; button.disabled = true; status.textContent = labels.loading || 'Loading more options…';
      state.controller = new AbortController();
      const timer = setTimeout(() => state.controller.abort(),25000);
      try {
        const url = new URL(state.next,location.origin);
        if (url.origin !== location.origin) throw Error('Invalid pagination');
        if (grid.dataset.id) url.searchParams.set('section_id', grid.dataset.id);
        const response = await fetch(url,{signal:state.controller.signal});
        if (!response.ok) throw Error('Unable to load');
        const html = await response.text();
        clearTimeout(timer);
        if (!await waitForScroll(state)) return;
        const doc = new DOMParser().parseFromString(html,'text/html');
        const newGrid = doc.querySelector('#product-grid');
        if (!newGrid || state !== active || state.url !== location.href) return;
        const cards = [...newGrid.children];
        if (!cards.length) throw Error('Empty page');
        const fragment = document.createDocumentFragment();
        for (const card of cards) {
          card.querySelectorAll('img').forEach(img => {img.loading='lazy';img.decoding='async';});
          fragment.append(card);
        }
        grid.append(fragment); state.next = nextURL(doc.querySelector('#ProductGridContainer') || doc);
        if (state.next) { const next = new URL(state.next, location.origin); next.searchParams.delete('section_id'); state.next = next.href; }
        state.pages++;
        status.textContent = ''; sync();
        document.dispatchEvent(new CustomEvent('njt:grid-appended'));
      } catch (error) {
        if (state !== active) return;
        status.textContent = labels.error || 'More options could not load. Please try again.';
        state.observer?.disconnect();
      } finally {clearTimeout(timer); state.busy=false;button.disabled=false;}
    };
    button.addEventListener('click',load);
    if ('IntersectionObserver' in window) {
      state.observer = new IntersectionObserver(entries => {if(entries.some(e=>e.isIntersecting))load();},{rootMargin:'400px 0px'});
      state.observer.observe(button);
    }
    sync();
    document.dispatchEvent(new CustomEvent('njt:list-ready'));
  }
  window.NJTInfiniteScroll = {init};
  document.addEventListener('njt:grid-updated',init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init); else init();
})();
